import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconHeadphones = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--headphones")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12,2 C17.5228474,2 22,6.47715241 22,12 L22,12 L22,18.9999999 C22,20.6568541 20.6568542,21.9999999 19,21.9999999 L18,21.9999999 C16.3431458,21.9999999 15,20.6568541 15,18.9999999 L15,15.9999999 C15,14.3431456 16.3431458,12.9999999 18,12.9999999 L20,12.999 L20,12 C20,7.66508567 16.5521622,4.13545713 12.2491793,4.00380682 L12,4 C7.58172205,4 4,7.58172193 4,12 L4,12 L4,12.999 L6,12.9999999 C7.65685425,12.9999999 9,14.3431456 9,15.9999999 L9,18.9999999 C9,20.6568541 7.65685425,21.9999999 6,21.9999999 L5,21.9999999 C3.34314575,21.9999999 2,20.6568541 2,18.9999999 L2,12 C2,6.47715241 6.47715256,2 12,2 Z M20,14.9999999 L18,14.9999999 C17.4477153,14.9999999 17,15.4477151 17,15.9999999 L17,18.9999999 C17,19.5522846 17.4477153,19.9999999 18,19.9999999 L19,19.9999999 C19.5522847,19.9999999 20,19.5522846 20,18.9999999 L20,14.9999999 Z M6,14.9999999 L4,14.9999999 L4,18.9999999 C4,19.5522846 4.44771525,19.9999999 5,19.9999999 L6,19.9999999 C6.55228475,19.9999999 7,19.5522846 7,18.9999999 L7,15.9999999 C7,15.4477151 6.55228475,14.9999999 6,14.9999999 Z" id="icon--centivo--headphones"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-963.000000, -636.000000)"/>
          <g id="Icon/headphones">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--headphones"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--headphones"/>
          </g>
      </g>
  </IconWrapper>
)
